import { Switch } from "@justhome/react-ui";
import { Control, Controller } from "react-hook-form";
import { FieldValues, FormFieldDefinition } from "./interfaces";

export interface SwitchFieldProps<T extends FieldValues> {
  fieldDefinition: FormFieldDefinition<T>;
  control: Control<T>;
}

const SwitchField = <T extends FieldValues>({
  fieldDefinition,
  control,
}: SwitchFieldProps<T>) => {
  return (
    <Controller
      control={control}
      name={fieldDefinition.name}
      rules={fieldDefinition.rules}
      defaultValue={fieldDefinition.defaultValue}
      render={({ field }) => (
        <Switch
          {...field}
          size="md"
          labelPosition="end"
          checked={field.value}
          label={fieldDefinition.label}
        />
      )}
    />
  );
};

export default SwitchField;
